import { AGGREGATE_NAMES, CHAT_RESOLVERS } from 'cpool-constants';
import { schemaChatResolver_GetInboxUnreadSummary } from 'cpool-tables/backend-resolvers';

import useUserInfo from '~/hooks/useUserInfo';
import { useQuery, useResolverAclGate } from '~/queryUtils/useQuery';
import { queryKeys } from '~/utils/queryKeys';

// Invalidated by useInboxSocket on WS push — stays live without a poll interval.
export const useInboxUnreadSummary = () => {
    const user = useUserInfo();
    const aclGate = useResolverAclGate({}, AGGREGATE_NAMES.CHAT, CHAT_RESOLVERS.getInboxUnreadSummary);

    return useQuery({
        aclAllowed: aclGate.allowed,
        queryKey: queryKeys.getInboxUnreadSummary(user?.id ?? ''),
        queryUrl: `/query/${AGGREGATE_NAMES.CHAT}/${CHAT_RESOLVERS.getInboxUnreadSummary}`,
        schema: schemaChatResolver_GetInboxUnreadSummary,
        tanstack: {
            enabled: Boolean(user),
        },
    });
};
